<template>
  <div class="maintenance-stats-container" style="height: 100%">
    <!-- 切换按钮组 -->
    <div class="tab-buttons">
      <div
        class="tab-button"
        :class="{ active: activeTab === 'current' }"
        @click="activeTab = 'current'"
      >
        当月年审
      </div>
      <div
        class="tab-button"
        :class="{ active: activeTab === 'overdue' }"
        @click="activeTab = 'overdue'"
      >
        超期年审
      </div>
      <div
        class="tab-button"
        :class="{ active: activeTab === 'unit' }"
        @click="activeTab = 'unit'"
      >
        维保单位
      </div>
      <div
        class="tab-button"
        :class="{ active: activeTab === 'surpass' }"
        @click="activeTab = 'surpass'"
      >
        超期维保
      </div>
      <div
        class="tab-button"
        :class="{ active: activeTab === 'experiment125' }"
        @click="activeTab = 'experiment125'"
      >
        125%试验
      </div>
      <div
        class="tab-button"
        :class="{ active: activeTab === 'unfinished' }"
        @click="activeTab = 'unfinished'"
      >
        未完成工单
      </div>
    </div>

    <!-- 弹窗组件 -->
    <el-dialog
      :title="`${selectedItem ? selectedItem.name : ''} - 详细数据`"
      :visible.sync="dialogVisible"
      width="90%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <!-- 搜索条件 -->
      <el-form :model="searchForm" ref="searchFormRef" class="search-form" inline>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="小区名称：" prop="communityName">
              <el-input
                v-model="searchForm.communityName"
                placeholder="请输入小区名称"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="检验机构：" prop="inspection_organization">
              <el-input
                v-model="searchForm.inspection_organization"
                placeholder="请输入检验机构"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="设备代码：" prop="device_code">
              <el-input
                v-model="searchForm.device_code"
                placeholder="请输入设备代码"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="年审时间：" prop="audittimes">
              <el-input
                v-model="searchForm.audittimes"
                placeholder="请输入年审时间"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="使用登记号：" prop="elevator_sign">
              <el-input
                v-model="searchForm.elevator_sign"
                placeholder="请输入使用登记号"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="电梯工号：" prop="elevator_number">
              <el-input
                v-model="searchForm.elevator_number"
                placeholder="请输入电梯工号"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="维保单位：" prop="wb_record_unit_name">
              <el-input
                v-model="searchForm.wb_record_unit_name"
                placeholder="请输入维保单位"
                clearable
                size="small"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <el-button type="primary" @click="handleSearch" icon="el-icon-search"
                >搜索</el-button
              >
              <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        style="width: 100%;"
        height="400"
        border
      >
        <el-table-column prop="name" label="小区名称" />
        <el-table-column prop="elevator_number" label="电梯工号" width="140" />
        <el-table-column prop="device_code" label="设备代码" width="200" />
        <el-table-column prop="elevator_sign" label="使用登记号" width="140" />
        <el-table-column prop="wb_record_unit_name" label="维保单位" />
        <el-table-column prop="inspection_organization" label="检验机构" width="220" />
        <el-table-column prop="audittimes" label="年审时间" width="80" />
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container" style="text-align: right">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        />
      </div>
    </el-dialog>

    <!-- 图表/列表内容区域 -->
    <div class="content-area">
      <!-- 电梯维保单位数量统计 -->
      <div v-show="activeTab === 'unit'" class="chart-container">
        <!-- <div class="chart-title" style="margin-top: 10px">电梯维保单位数量统计</div> -->
        <div id="barHorizontalChart" style="width: 100%; height: 100%"></div>
      </div>

      <!-- 超期年审统计列表 -->
      <div v-show="activeTab === 'overdue'" class="list-container">
        <!-- <div class="chart-title" style="margin-top: 10px">超期年审统计</div> -->
        <div class="list-content">
          <div v-if="!overdueAuditData.length" class="empty-data">暂无数据</div>
          <div v-else class="record-table">
            <div class="record-header overdue-header">
              <div class="header-item">序号</div>
              <div class="header-item">项目地址</div>
              <div class="header-item">设备代码</div>
              <div class="header-item">年审时间</div>
              <div class="header-item">检验机构</div>
            </div>
            <div class="record-body">
                <div
                  class="record-row"
                  v-for="(item, index) in overdueAuditData"
                  :key="index"
                >
                  <div class="record-index">{{ index + 1 }}</div>
                  <div class="record-overdue-name">{{ item.name || "-" }}</div>
                  <div class="record-code">{{ item.device_code || "-" }}</div>
                  <div class="record-time">{{ item.audittimes || "-" }}</div>
                  <div class="record-inspection">{{ (item.inspection_organization && item.inspection_organization.slice(0,2)) || "-" }}</div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 当月年审统计列表 -->
      <div v-show="activeTab === 'current'" class="list-container">
        <!-- <div class="chart-title" style="margin-top: 10px">当月年审统计</div> -->
        <div class="list-content">
          <div v-if="!currentAuditData.length" class="empty-data">暂无数据</div>
          <div v-else class="record-table">
            <div class="record-header current-header">
              <div class="header-item">序号</div>
              <div class="header-item">项目地址</div>
              <div class="header-item">设备代码</div>
              <div class="header-item">年审时间</div>
              <div class="header-item">检验机构</div>
            </div>
            <div class="record-body">
                <div
                  class="record-row"
                  v-for="(item, index) in currentAuditData"
                  :key="index"
                >
                  <div class="record-index">{{ index + 1 }}</div>
                  <div class="record-current-name">{{ item.name || "-" }}</div>
                  <div class="record-code">{{ item.device_code || "-" }}</div>
                  <div class="record-time">{{ item.audittimes || "-" }}</div>
                  <div class="record-inspection">{{ (item.inspection_organization && item.inspection_organization.slice(0,2)) || "-" }}</div>
                </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 超期维保统计列表 -->
      <div v-show="activeTab === 'surpass'" class="list-container overdue-maintenance-list">
        <!-- <div class="chart-title" style="margin-top: 10px">超期维保统计</div> -->
        <div class="list-content">
          <div v-if="!surpassWbData.length" class="empty-data">暂无数据</div>
          <div v-else class="record-table">
            <div class="record-header">
              <div class="header-item">序号</div>
              <div class="header-item">项目地址</div>
              <!-- <div class="header-item">设备代码</div> -->
              <div class="header-item">上次维保作业时间</div>
            </div>
            <div class="record-body">
              <div
                class="record-row"
                v-for="(item, index) in surpassWbData"
                :key="index"
              >
                <div class="record-index">{{ index + 1 }}</div>
                <div class="record-name" style="flex:3;">{{ item.name || "-" }}</div>
                <!-- <div class="record-code">{{ item.device_code || "-" }}</div> -->
                <div class="record-time" style="flex: 1.5;">{{ item.latestMaintenanceDate || "-" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 未完成工单统计列表 -->
      <div v-show="activeTab === 'unfinished'" class="list-container unfinished-order-list">
        <!-- <div class="chart-title" style="margin-top: 10px">未完成工单统计</div> -->
        <div class="list-content">
          <div v-if="!unfinishedOrderData.length" class="empty-data">暂无数据</div>
          <div v-else class="record-table">
            <div class="record-header">
              <div class="header-item">序号</div>
              <div class="header-item">项目地址</div>
              <div class="header-item">紧急程度</div>
              <div class="header-item">工单类型</div>
              <div class="header-item">负责员工</div>
            </div>
            <div class="record-body">
              <div
                class="record-row"
                v-for="(item, index) in unfinishedOrderData"
                :key="index"
              >
                <div class="record-index">{{ index + 1 }}</div>
                <div class="record-unfinished-name" :title="item.area_name || '-'">{{ item.area_name || "-" }}</div>
                <div class="record-level">{{ getLevelText(item.level) }}</div>
                <div class="record-type">{{ getOrderTypeText(item.order_type) }}</div>
                <div class="record-staff">{{ item.repair_staff_name || "-" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 125%试验统计列表 -->
      <div v-show="activeTab === 'experiment125'" class="list-container">
        <!-- <div class="chart-title" style="margin-top: 10px">125%试验统计</div> -->
        <div class="list-content">
          <div v-if="!experiment125Data.length" class="empty-data">暂无数据</div>
          <div v-else class="record-table">
            <div class="record-header experiment125-header">
              <div class="header-item">序号</div>
              <div class="header-item">项目地址</div>
              <div class="header-item">设备代码</div>
              <div class="header-item">年审时间</div>
              <div class="header-item">检验机构</div>
            </div>
            <div class="record-body">
              <div
                class="record-row"
                v-for="(item, index) in experiment125Data"
                :key="index"
              >
                <div class="record-index">{{ index + 1 }}</div>
                <div class="record-experiment125-name">{{ item.name || "-" }}</div>
                <div class="record-code">{{ item.device_code || "-" }}</div>
                <div class="record-time">{{ item.audittimes || "-" }}</div>
                <div class="record-inspection">{{ (item.inspection_organization && item.inspection_organization.slice(0,2)) || "-" }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import { dashboardAPI } from "@/api/dashboard";

export default {
  name: "MaintenanceUnitStats",
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
    overdueAuditData: {
      type: Array,
      default: () => [],
    },
    currentAuditData: {
      type: Array,
      default: () => [],
    },
    surpassWbData: {
      type: Array,
      default: () => [],
    },
    experiment125Data: {
      type: Array,
      default: () => [],
    },
    unfinishedOrderData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartInstance: null,
      originalChartData: [], // 保存原始图表数据，用于点击事件匹配
      activeTab: "current", // unit: 维保单位, overdue: 超期年审, current: 当月年审, surpass: 超期维保, experiment125: 125%试验, unfinished: 未完成工单
      // 弹窗相关数据
      dialogVisible: false,
      selectedItem: null,
      tableData: [],
      tableLoading: false,
      searchForm: {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      },
      pagination: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  watch: {
    chartData: {
      handler() {
        if (this.activeTab === "unit") {
          this.$nextTick(() => {
            this.updateChart();
          });
        }
      },
      deep: true,
    },
    activeTab(newVal) {
      if (newVal === "unit") {
        this.$nextTick(() => {
          this.initChart();
          this.updateChart();
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.activeTab === "unit") {
        this.initChart();
        this.updateChart();
      }
    });

    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    this.loadTableData();
  },
  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.dispose();
    }
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    initChart() {
      const chartDom = document.getElementById("barHorizontalChart");
      if (chartDom) {
        this.chartInstance = echarts.init(chartDom);

        // 添加点击事件
        this.chartInstance.on("click", (params) => {
          this.handleBarClick(params);
        });
      }
    },
    // 获取紧急程度文本
    getLevelText(level) {
      const levelMap = {
        1: "低",
        2: "中",
        3: "高",
        4: "紧急"
      };
      return levelMap[level] || "-";
    },

    // 获取工单类型文本
    getOrderTypeText(orderType) {
      const orderTypeMap = {
        1: "电梯故障",
        2: "维修记录",
        3: "改造记录",
        4: "大修记录",
        5: "困人记录",
        6: "其他记录"
      };
      return orderTypeMap[orderType] || "-";
    },

    // 检查文字是否被截断
    isTextTruncated(element) {
      if (!element) return false;
      return element.scrollWidth > element.clientWidth;
    },

    // 检查项目地址是否需要显示悬停提示
    shouldShowTooltip(text, element) {
      if (!text || text === '-') return false;
      return this.isTextTruncated(element);
    },

    updateChart() {
      if (!this.chartInstance || !this.chartData.length) return;

      // 保存原始数据用于点击事件匹配
      this.originalChartData = [...this.chartData];

      // 反转数据顺序，让数值大的显示在上面
      const sortedData = [...this.chartData].reverse();

      // 动态计算X轴最大值
      const maxValue = Math.max(...this.chartData.map((item) => item.value), 100);
      const xAxisMax = Math.ceil(maxValue / 50) * 50 + 20;

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          backgroundColor: "rgba(0, 0, 0, 0.8)",
          borderColor: "#00d4ff",
          textStyle: { color: "#fff" },
        },
        grid: {
          left: "5%",
          right: "5%",
          bottom: "2%",
          top: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          max: xAxisMax,
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff" },
          splitLine: { lineStyle: { color: "rgba(0, 212, 255, 0.2)" } },
        },
        yAxis: {
          type: "category",
          data: sortedData.map((item) => item.name),
          axisLine: { lineStyle: { color: "#00d4ff" } },
          axisLabel: { color: "#fff", fontSize: 10 },
        },
        series: [
          {
            data: sortedData.map((item) => item.value),
            type: "bar",
            barWidth: "60%",
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: "#0088cc" },
                { offset: 1, color: "#00d4ff" },
              ]),
              borderRadius: [0, 4, 4, 0],
            },
            label: {
              show: true,
              position: "inside",
              color: "#fff",
              fontSize: 12,
              fontWeight: "bold",
              formatter: "{c}",
            },
          },
        ],
      };
      this.chartInstance.setOption(option);
    },
    handleResize() {
      if (this.chartInstance) {
        this.chartInstance.resize();
      }
    },

    // 处理柱状图点击事件
    handleBarClick(params) {
      // 由于图表数据被反转显示，需要根据显示的索引找到原始数据中的对应项
      // params.dataIndex 是反转后数据的索引，需要映射回原始数据
      const sortedData = [...this.chartData].reverse();
      const clickedItem = sortedData[params.dataIndex];

      // 在原始数据中找到匹配的项
      this.selectedItem = this.chartData.find(item => item.name === clickedItem.name);

      this.dialogVisible = true;
      this.pagination.currentPage = 1;
      this.searchForm = {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      };
      this.loadTableData();
    },

    // 加载表格数据
    async loadTableData() {
      this.tableLoading = true;
      try {
        const params = {
          wb_record_unit_name: this.selectedItem ? this.selectedItem.name : "",
          ...this.searchForm,
        };

        const response = await dashboardAPI.getProjectListByRegion(params);

        if (response.code === 1) {
          const allData = response.data || [];
          this.pagination.total = allData.length;

          // 前端分页处理
          const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
          const end = start + this.pagination.pageSize;
          this.tableData = allData.slice(start, end);
        } else {
          this.$message.error(response.msg || "获取数据失败");
        }
      } catch (error) {
        console.error("加载表格数据失败:", error);
        this.$message.error("加载数据失败");
      } finally {
        this.tableLoading = false;
      }
    },

    // 搜索
    handleSearch() {
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        communityName: "",
        inspection_organization: "",
        device_code: "",
        audittimes: "",
        elevator_sign: "",
        elevator_number: "",
      };
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 分页大小改变
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.currentPage = 1;
      this.loadTableData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.loadTableData();
    },

    // 获取状态标签类型
    getStatusType(status) {
      const statusMap = {
        正常: "success",
        异常: "danger",
        待检: "warning",
        维修中: "info",
      };
      return statusMap[status] || "info";
    },
  },
};
</script>

<style scoped>
.maintenance-stats-container {
  background: rgba(10, 25, 41, 0.8);
  border: 1px solid rgba(0, 212, 255, 0.3);
  border-radius: 10px;
  padding: 15px;
  box-sizing: border-box;
  box-shadow: 0 0 20px rgba(0, 212, 255, 0.2);
  height: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* 弹窗样式优化 - 仅保留标题颜色以保持一致性 */
.el-dialog__title {
  color: #00d4ff !important;
}

/* 分页容器样式 */
.pagination-container {
  padding: 10px 0;
}

.maintenance-stats-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent, rgba(0, 212, 255, 0.8), transparent);
}

/* 切换标签样式 */
.tab-buttons {
  display: flex;
  gap: 15px;
  margin-bottom: 8px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: bold;
}

.tab-button {
  color: #88c4ff;
  cursor: pointer;
  transition: all 0.3s;
  white-space: nowrap;
  position: relative;
  padding: 2px 0;
}

.tab-button:hover {
  color: #00d4ff;
}

.tab-button.active {
  color: #00d4ff;
}

.tab-button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, #00d4ff, #0088cc);
  border-radius: 1px;
}

.content-area {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 452px;
}

.chart-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.list-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chart-title {
  font-size: 16px;
  margin-bottom: 10px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

.list-content {
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.empty-data {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88c4ff;
  font-size: 14px;
}

.record-table {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.record-header {
  display: flex;
  padding: 8px 0;
  border-bottom: 2px solid rgba(0, 212, 255, 0.5);
  margin-bottom: 8px;
  flex-shrink: 0;
}

.header-item {
  font-weight: bold;
  color: #00d4ff;
  text-align: center;
  font-size: 12px;
}

/* 超期年审表头居中对齐和宽度设置 */
.overdue-header {
  display: flex;
  width: 100%;
}

.overdue-header .header-item:nth-child(1) {
  /* width: 5%; */
  width: 40px;
  flex-shrink: 0;
}

.overdue-header .header-item:nth-child(2) {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
}

.overdue-header .header-item:nth-child(3) {
  width: 150px;
  flex-shrink: 0;
}

.overdue-header .header-item:nth-child(4) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

.overdue-header .header-item:nth-child(5) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

/* 当月年审表头居中对齐和宽度设置 */
.current-header {
  display: flex;
  width: 100%;
}

.current-header .header-item:nth-child(1) {
  /* width: 5%; */
  width: 40px;
  flex-shrink: 0;
}

.current-header .header-item:nth-child(2) {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
}

.current-header .header-item:nth-child(3) {
  width: 150px;
  flex-shrink: 0;
}

.current-header .header-item:nth-child(4) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

.current-header .header-item:nth-child(5) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

.record-body {
  flex: 1;
  overflow-y: auto;
}

.record-row {
  display: flex;
  width: 100%;
  padding: 6px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background-color 0.3s;
  font-size: 12px;
  align-items: center;
}

.record-row:hover {
  background-color: rgba(0, 212, 255, 0.1);
}

.record-overdue-name {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
  color: #ffffff;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.record-current-name {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
  color: #ffffff;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.record-unfinished-name {
  flex: 3;
  color: #ffffff;
  text-align: center;
  padding: 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

.record-code {
  width: 150px;
  color: #ffffff;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-time {
  flex: 0.5;
  min-width: 60px;
  color: #00d4ff;
  text-align: center;
  flex-shrink: 0;
}

.record-level {
  flex: 1;
  color: #ffffff;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-type {
  flex: 1;
  color: #ffffff;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.record-staff {
  flex: 1;
  color: #00d4ff;
  text-align: center;
  padding: 0 4px;
}

/* 125%试验表头宽度设置 */
.experiment125-header {
  justify-content: center;
}

.record-index {
  width: 40px;
  color: #00d4ff;
  text-align: center;
  font-weight: bold;
}

.record-experiment125-name {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
  color: #ffffff;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
}

/* 超期维保表头宽度设置 - 使用类名 */
.overdue-maintenance-list .record-header {
  justify-content: center;
}

.overdue-maintenance-list .record-header .header-item:nth-child(1) {
  width: 40px;
}

.overdue-maintenance-list .record-header .header-item:nth-child(2) {
  flex: 3;
}

.overdue-maintenance-list .record-header .header-item:nth-child(3) {
  flex: 1.5;
}

.record-time {
  color: #00d4ff;
  text-align: center;
}

/* 滚动条样式 */
.record-body::-webkit-scrollbar {
  width: 4px;
}

.record-body::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 2px;
}

.record-body::-webkit-scrollbar-thumb {
  background: rgba(0, 212, 255, 0.5);
  border-radius: 2px;
}

.record-body::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 212, 255, 0.8);
}

/* 未完成工单表头宽度设置 - 使用类名 */
.unfinished-order-list .record-header {
  justify-content: center;
}

.unfinished-order-list .record-header .header-item:nth-child(1) {
  width: 40px;
}

.unfinished-order-list .record-header .header-item:nth-child(2) {
  flex: 3;
}

.unfinished-order-list .record-header .header-item:nth-child(3) {
  flex: 1;
}

.unfinished-order-list .record-header .header-item:nth-child(4) {
  flex: 1;
}

.unfinished-order-list .record-header .header-item:nth-child(5) {
  flex: 1;
}

/* 125%试验表头及内容列宽度设置 */
.experiment125-header {
  display: flex;
  width: 100%;
}

.experiment125-header .header-item:nth-child(1) {
  /* width: 5%; */
  width: 40px;
  flex-shrink: 0;
}

.experiment125-header .header-item:nth-child(2) {
  flex: 1.5;
  min-width: 120px;
  margin: 0 4px;
}

.experiment125-header .header-item:nth-child(3) {
  width: 20%;
  width: 150px;
  flex-shrink: 0;
}

.experiment125-header .header-item:nth-child(4) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

.experiment125-header .header-item:nth-child(5) {
  flex: 0.5;
  min-width: 60px;
  flex-shrink: 0;
}

.record-time {
  flex: 0.5;
  min-width: 60px;
  color: #00d4ff;
  text-align: center;
  flex-shrink: 0;
}

.record-inspection {
  flex: 0.5;
  min-width: 60px;
  color: #ffffff;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-shrink: 0;
}
</style>
